import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg py-4' : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link 
          to="/"
          className="text-2xl font-bold cursor-pointer"
          style={{ 
            fontFamily: "'Klee One', cursive",
            color: isScrolled ? '#6B4E3D' : '#FFFFFF'
          }}
        >
          いまのきもち
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#services" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">サービス内容</a>
          <Link to="/profile" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">セラピスト紹介</Link>
          <Link to="/payment" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">お支払い</Link>
          <Link to="/booking-guide" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">予約方法</Link>
          <Link to="/faq" className="text-gray-700 hover:text-gray-900 transition-colors text-sm">よくある質問</Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
        >
          <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
            isScrolled ? 'text-gray-700' : 'text-white'
          } w-6 h-6 flex items-center justify-center`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg mt-4">
          <div className="px-6 py-4 flex flex-col gap-4">
            <a href="#services" className="block py-4 text-gray-700 hover:text-gray-900 transition-colors">サービス内容</a>
            <Link to="/profile" className="block py-4 text-gray-700 hover:text-gray-900 transition-colors">セラピスト紹介</Link>
            <Link to="/payment" className="block py-4 text-gray-700 hover:text-gray-900 transition-colors">お支払い</Link>
            <Link to="/booking-guide" className="block py-4 text-gray-700 hover:text-gray-900 transition-colors">予約方法</Link>
            <Link to="/faq" className="block py-4 text-gray-700 hover:text-gray-900 transition-colors">よくある質問</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
